import React from 'react'
import TimelineContent from '../timeline-content'

export default function TimelineContentDisplay(props) {
  const page = props?.node

  return <TimelineContent page={page} />
}
